module.exports = __webpack_public_path__ + "static/media/E-flat-7ths.17f8a1ae.png";